import React from 'react';
import { Box, Card } from '@material-ui/core';
import styled, { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.min.css';

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
  }

  html {
    word-break: normal;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: space-between;
    align-items: stretch;
  }

  body {
    font-family: 'Poppins', sans-serif;
    min-height: 100vh;
    background-color: #fff;
    @media (prefers-color-scheme: dark) {
      background-color: #fff;
    }
  }

  .MuiFormControl-marginNormal {
    margin-top: 10px;
  }
`;

export const Form = styled(Card)
  .attrs({
    elevation: 3,
  })
  .withConfig({
    shouldForwardProp: prop => !['maxWidth'].includes(prop),
  })`
  max-width: ${props => props.maxWidth || 360}px;
  width: 100%;
  margin: auto;

  ${props => props.theme.breakpoints.down('sm')} {
    // height: 100%;
    border-radius: 0;
  }

  ${props => props.theme.breakpoints.down('xs')} {
    max-width: none;
  }
`;

export function FormContainer({ children, maxWidth = 360 }) {
  return (
    <Form maxWidth={maxWidth}>
      <Box width="100%" p={3}>
        {children}
      </Box>
    </Form>
  );
}

export default GlobalStyle;
